/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React, { Suspense } from 'react'
import { useTypedSelector } from 'helpers/reducers'
import UiLoader from 'components/Ui/UiLoader'
import clsx from 'clsx'

interface LoaderProps {
    usereducer?: boolean
    naked?: boolean
}

const Loader = (props: LoaderProps) => {
    const ajaxLoading = useTypedSelector((state) => state.common.ajaxLoading)

    if (ajaxLoading === 0 && props.usereducer) {
        return null
    }

    if (props.naked) {
        return <UiLoader variant="ellipsis" />
    }

    return (
        <div className={clsx('Loader', 'w-full absolute left-0 z-110')}>
            <Suspense fallback={null}>
                <UiLoader variant={props.usereducer ? 'bar' : 'ellipsis'} />
            </Suspense>
        </div>
    )
}

export default Loader
